import React, { useEffect, useState } from "react";
import "../../css/Blogs.css";
import axios from "axios";
import Pagination from "../common/Pagination";
import dummyImage from "../../images/no-image-thumb.jpg";
import Slider from "react-slick";

const Blogs = () => {
  const [gettopblogs, setGetTopBlogs] = useState([]);
  const [getpopularblogs, setGetPopularBlogs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [category, setCategory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch Top Blogs from the API
  const fetchTopBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getTopBlogs`
      );
      if (response.data.status === true) {
        setGetTopBlogs(response.data.data);
      } else {
        setGetTopBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching top blogs:", error);
      setGetTopBlogs([]);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Popular Blogs List from the API
  const fetchPopularBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getPopularBlogs`
      );
      if (response.data.status === true) {
        setGetPopularBlogs(response.data.data);
      } else {
        setGetPopularBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching top blogs:", error);
      setGetPopularBlogs([]);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Blogs List from the API
  const fetchBlogs = async (page = 1, category) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getBlogs`,
        {
          params: {
            page,
            limit: 6,
            ...(category && { category }), // Only include category if it's not empty
          },
        }
      );

      if (response.data.status === true) {
        setBlogs(response.data.data);
        setCurrentPage(page);
        const totalItems = response.data.total || 0;
        setTotalPages(Math.ceil(totalItems / 6));
      } else {
        setBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Blogs Category from the API
  const fetchBlogsCategory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getBlogsCategory`
      );
      if (response.data.status === true) {
        setCategory(response.data.data);
      } else {
        setCategory([]);
      }
    } catch (error) {
      console.error("Error fetching top blogs:", error);
      setCategory([]);
    } finally {
      setLoading(false);
    }
  };
  // Convert CkEditor data into plain text
  const getPlainTextSnippet = (html, wordLimit = 30) => {
    const plainText = html.replace(/<[^>]+>/g, "");
    return plainText.split(/\s+/).slice(0, wordLimit).join(" ") + "...";
  };

  const getPlainTextSnippetdesc = (html) => {
  return html.replace(/<[^>]+>/g, ""); // remove HTML tags
};

  const handleCategoryClick = (e, selectedCategory) => {
    e.preventDefault();
    const Category = selectedCategory === "All" ? "" : selectedCategory;
    setActiveCategory(selectedCategory);
    fetchBlogs(1, Category); // page 1, with selected category
  };
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[\s&]+/g, "-") // replace spaces and & with hyphen
      .replace(/[^a-z0-9\-]/g, "") // remove special characters except hyphen
      .replace(/-+/g, "-"); // collapse multiple hyphens
  }
  const handleLinkClick = (blog) => {
    if (!blog) return;

    let categorys = blog?.category_name;
    let contentType = blog?.content_type;
    // let subCategory = blog?.sub_category_name;
    let slug = blog?.slug;
    let categorySlug = `${slugify(categorys)}`;
    const url = `/${contentType}/${categorySlug}/${slug}`;

    // Open in a new tab
    window.open(url, "_blank");
  };
  useEffect(() => {
    fetchTopBlogs();
    fetchBlogs();
    fetchBlogsCategory();
    fetchPopularBlogs();
    setActiveCategory("All");
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Adjust based on design
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <>
      <section className="blog-section sectiontopgap sectionbotgap">
        <div className="container-fluid">
          <div className="row latest-three">
            {gettopblogs.length > 0 && (
              <>
                {/* First blog - large */}
                <div className="col-md-8 col-12">
                  <div
                    onClick={() => {
                      handleLinkClick(gettopblogs[0]);
                    }}
                  >
                    <div className="bigblog-mask-container">
                      <img
                        src={gettopblogs[0]?.imagePath || dummyImage}
                        className="target-image"
                        style={{height:'100%'}}
                        alt="Blog 1"
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop
                          e.target.src = dummyImage; // Fallback image
                        }}
                      />
                      <div className="blogovrlydata">
                        <h2 className="h2_padding">{gettopblogs[0].title || ""}</h2>
                        <p >
                          {getPlainTextSnippet(
                            gettopblogs[0]?.description || ""
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Next blogs - small */}
                <div className="col-md-4 col-12">
                  {gettopblogs.slice(1).map((blog, index) => (
                    <div className="smlblog-mask-container" key={index}>
                      <div
                        onClick={() => {
                          handleLinkClick(blog);
                        }}
                      >
                        <img
                          src={blog.imagePath || dummyImage}
                          className="target-image"
                          style={{height:'100%'}}
                          alt={`Blog ${index + 2}`}
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = dummyImage; // Fallback image
                          }}
                        />
                        <div className="blogovrlydata">
                          <h2 className="h2_padding">
                            {blog?.title
                              ? blog.title.split(" ").slice(0, 8).join(" ") +
                                "..."
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      <section className="allblogs-section sectiontopgap sectionbotgap">
        <div className="container-fluid">
          <div className="blogarea">
            <div className="leftwithblogs">
              <div className="blogmobcat mob">
                <h6>Category:</h6>
                <ul className="blogcats">
                  <li
                    className={activeCategory === "All" ? "active" : ""}
                    onClick={(e) => handleCategoryClick(e, "All")}
                  >
                    <a href="#">All</a>
                  </li>
                  {category.map((data, index) => (
                    <li
                      key={index}
                      className={
                        activeCategory === data.category ? "active" : ""
                      }
                      onClick={(e) => handleCategoryClick(e, data.category)}
                    >
                      <a
                        href=""
                        className={
                          activeCategory === data.category ? "active" : ""
                        }
                      >
                        {data.category}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              {blogs.length > 0 ? (
                <>
                  <div className="row">
                    {blogs.map((blog, index) => (
                      <div className="col-md-4 col-12" key={index}>
                        <div
                         
                        >
                          <div className="allblog-mask-container">
                            <img
                              src={blog.imagePath || dummyImage}
                              className="target-image-blog"
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = dummyImage; // Fallback image
                              }}
                            />
                          </div>
                          <div className="allblog-data">
                            <h2 className="h2_padding" style={{height:'25px', overflow:'hidden'}}>
                              {/* {blog.title?.split(" ").slice(0, 5).join(" ")}... */}
                              {blog?.title
                                ? blog.title.split(" ").slice(0, 4).join(" ") +
                                  "..."
                                : ""}
                            </h2>
                            <p className="snippet" style={{height:'116px'}}>{getPlainTextSnippetdesc(blog.description || "")}</p>
                            <div className="btnbx">
                              <button class="btn faci_button" type="button" style={{height:'30px'}}  onClick={() => {
                            handleLinkClick(blog);
                          }}>
                                <span>Read More</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center py-4">
                    <h5>No Blog found</h5>
                  </div>
                </>
              )}
            </div>
            <div className="rightwithads desk">
              <div className="row">
                {category.length > 0 && (
                  <div className="col-md-12 col-12">
                    <div className="sectiontitle mb-3">
                      <div className="titleunderline">
                        <svg
                          width="64"
                          height="3"
                          viewBox="0 0 64 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 1.5H62"
                            stroke="#F68633"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h5>Categories</h5>
                    </div>

                    <ul className="blogcats">
                      <li
                        className={activeCategory === "All" ? "active" : ""}
                        onClick={(e) => handleCategoryClick(e, "All")}
                      >
                        <a href="#">All</a>
                      </li>
                      {category.map((data, index) => (
                        <li
                          key={index}
                          className={
                            activeCategory === data.category ? "active" : ""
                          }
                          onClick={(e) => handleCategoryClick(e, data.category)}
                        >
                          <a
                            href=""
                            className={
                              activeCategory === data.category ? "active" : ""
                            }
                          >
                            {data.category}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {getpopularblogs.length > 0 && (
                  <div className="col-md-12 col-12">
                    <div className="sectiontitle mb-3">
                      <div className="titleunderline">
                        <svg
                          width="64"
                          height="3"
                          viewBox="0 0 64 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 1.5H62"
                            stroke="#F68633"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h5>Popular Blogs</h5>
                    </div>
                    <div style={{ height: "553px", overflow: "auto" }}>
                      {getpopularblogs.map((data, index) => (
                        <div className="smlblog-mask-container" key={index}>
                          <div
                            onClick={() => {
                              handleLinkClick(data);
                            }}
                          >
                            <img
                              src={data.imagePath || dummyImage}
                              className="target-image"
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = dummyImage; // Fallback image
                              }}
                            />
                            <div className="blogovrlydata">
                              <h2>
                                {/* {data.title?.split(" ").slice(0, 5).join(" ")}
                                ... */}
                                {data?.title
                                  ? data.title
                                      .split(" ")
                                      .slice(0, 5)
                                      .join(" ") + "..."
                                  : ""}
                              </h2>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {blogs.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={fetchBlogs}
          />
        )}

        <div className="col-md-12 col-12 mob">
          <div className="sectiontitle mb-3">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <h5>Popular Blogs</h5>
          </div>

          <Slider {...settings}>
            {getpopularblogs.map((data, index) => (
              <div className="smlblog-mask-container p-2" key={index}>
                <div onClick={() => handleLinkClick(data)}>
                  <img
                    src={data.imagePath || dummyImage}
                    className="target-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = dummyImage;
                    }}
                  />
                  <div className="blogovrlydata" style={{width:'96%',left:'9px'}}>
                    <h2 className="h2_padding">
                      {data?.title
                        ? data.title.split(" ").slice(0, 5).join(" ") + "..."
                        : ""}
                    </h2>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default Blogs;
